import React from "react";
import classnames from "classnames";
import { UserBatchValidateResult } from "../../../application/domain/user/user-batch-import-result";

export const BatchImportResult: React.FC<{
  process: "更新" | "登録";
  validateResult: UserBatchValidateResult;
  count: number;
  onClose: () => void;
}> = ({ process, validateResult, count, onClose }) => {
  return (
    <>
      <section className="modal-card-body">
        {validateResult.results.length}
        件の一括{process}を実行し、差分があった{count}
        件のユーザーを{process}しました。
      </section>
      <footer className="modal-card-foot">
        <button
          className={classnames("button is-fullwidth")}
          onClick={onClose}
          disabled={false}
        >
          閉じる
        </button>
      </footer>
    </>
  );
};
